import { Redline } from 'redline-client-sdk';

import type { AtendeAgreementOutcomeReceived, AtendeOfferAgreementCreated } from './types';

export const atendeEvents = (rl: Redline) => ({

  /**
   * @deprecated Substituído por offerAgreementCreated após rollout do checkout renegkit.
   * @description Rastreia o fechamento de acordo no fluxo legado via Atende.
   */
  agreementOutcomeReceived(props: AtendeAgreementOutcomeReceived) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rl.track('atende.AgreementOutcomeReceived.v1', props as any);
  },

  /**
   * @description Rastreia o fechamento de acordo no checkout renegkit quando realizado via Atende (evento presencial).
   * Equivalente ao renegkit.OfferAgreementCreated.v1 com o campo adicional atendeUser.
   *
   * @param {string} props.atendeUser - Identificador (e-mail) do operador Atende.
   *
   * @example
   * track.atende.offerAgreementCreated({
   *   atendeUser: 'operador@empresa.com.br',
   *   correlationId: '123|creditor',
   *   offerId: 123,
   *   // ...demais campos de renegkit.OfferAgreementCreated.v1
   * });
   */
  offerAgreementCreated(props: AtendeOfferAgreementCreated) {
    return rl.track('atende.OfferAgreementCreated.v1', props);
  },
});